import classNames from 'classnames'

import { useSignOut } from '../../hooks/use-sign-out'

export function LogoutButton() {
    const logout = useSignOut()
    const wrapperClasses = classNames(
        'group',
        'bg-white rounded-sm',
        'border border-danger box-border',
        'shadow-md',
        'transition-opacity',
        'hover:opacity-100',
        'flex flex row p-2 items-center px-8 mt-6 cursor-pointer',
        'text-danger',
        'hover:bg-danger hover:text-white',
    )

    return (
        <div
            className={wrapperClasses}
            style={{
                width: 'max-content',
            }}
            onClick={logout}>
            Log me out
        </div>
    )
}
